import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store';
import { GET_USER_TYPE_LIST,
         GET_SELECTED_USER_TYPE,
         GET_REGISTER_FORM_VISIBILITY } from './types';

export const getters: GetterTree<State, RootState> = {
    [GET_USER_TYPE_LIST](state: State) {
        return state.userTypes;
    },
    [GET_SELECTED_USER_TYPE](state: State) {
        return state.userTypeSelected;
    },
    [GET_REGISTER_FORM_VISIBILITY](state: State) {
        return state.showRegisterForm;
    },
};
